function convertDMS(lat, lng) {
  const convertLat = Math.abs(lat)
  const LatDeg = Math.floor(convertLat)
  const LatMin = ((convertLat - LatDeg) * 60).toFixed(0)
  const LatCardinal = ((lat > 0) ? 'N' : 'S')
  const convertLng = Math.abs(lng)
  const LngDeg = Math.floor(convertLng)
  const LngMin = ((convertLng - LngDeg) * 60).toFixed(0)
  const LngCardinal = ((lng > 0) ? 'E' : 'W')
  return LatDeg + '°' + LatMin + '\'' + LatCardinal + ', ' + LngDeg + '°' + LngMin + '\'' + LngCardinal
}

export {
  convertDMS
}